<template>
  <div id="extended-container">
    <div class="button-group">
      <div class="btn-bulk-close position-relative">
        <a class="btn" href="/api/planning/export" download>Export All</a>
      </div>
    </div>
    <tabs class="ses-tabs" :fill="0" :pills="0" :activeTab="0">
      <card shadow>
        <tab-pane :key="1" :title="'Planning'" :id="1">
          <div class="row">
            <div class="col-lg-12">
              <div class="filter-wrapper">
                <p class="title">Manage Filter:</p>
                <div class="filter-container">
                  <div class="filter-item search-filter">
                    <input type="text" placeholder="Search" v-model="filters.search" @keyup.enter="filterList">
                    <button type="button" @click="filterList"><i class="fa fa-search"></i></button>
                  </div>
                  <div class="filter-reset-btn">
                    <a href="javascript:void(0)" title="Refresh" @click="resetFilter">
                      <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="filter-item filter-legend">
                    <span>Legends:</span>
                    <div class="legend" style="background:lightgreen;">Processed</div>
                    <div class="legend" style="background:yellow;">Process By EOD</div>
                    <div class="legend" style="background:lightblue;">Waiting on SO Approval</div>
                    <div class="legend" style="background:orange;">Not Coming This Week</div>
                    <div class="legend" style="background:red;">Job is Lost</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <div id="list-projj" class="list-proj">
                  <div class="row list-head">
                    <div class="col col-check"><input type="checkbox" v-model="all_select" ref="selectAll" @change="selectAll($event)"></div>
                    <div class="col" data-key="quote_number" @click="sortList">SO/Case</div>
                    <div class="col" data-key="company_name" @click="sortList">Customer</div>
                    <div class="col" data-key="project_name" @click="sortList">Project Name</div>
                    <div class="col" data-key="project_total" @click="sortList">Total</div>
                    <div class="col" data-key="status" @click="sortList">Status</div>
                    <div class="col" data-key="approval">Approval</div>
                    <div class="col" data-key="po">PO</div>
                    <div class="col" data-key="notes">Estimated Date</div>
                    <div class="col" data-key="last_followup">Last <small>Follow Up</small></div>
                    <div class="col" data-key="next_followup">Next <small>Follow Up</small></div>
                  </div>
                  <div v-for="(projects, category) in plannings" :key="category">
                    <div class="list-row">
                      <div class="row list-data">
                        <div class="col list-category"><h5>{{ category }}</h5> <a @click="selectByCat(category)">Select All</a></div>
                      </div>
                    </div>
                    <div class="list-row" v-for="(row, di) in projects" :key="category+di" @click="toggleNotes(row.id)">
                      <template v-if="row">
                        <div :class="'row list-data'+(row.color?' f-color':'')" :data-row="di" :style="(row.color?'background:'+row.color:'')">
                          <div class="col col-check"><input type="checkbox" :value="row" :category="category" name="checkedPlans" ref="checkedPlans" v-model="checkedPlans" @change="setCheckedPlans"></div>
                          <div class="col">{{ row.quote_number }}</div>
                          <div class="col">{{ row.company_name }}</div>
                          <div class="col" style="word-break: break-word;">{{ row.project_name }}</div>
                          <div class="col">{{ formatNum(row.project_total) }}</div>
                          <div class="col">{{ row.status }}</div>
                          <div class="col">{{ row.approval ? '✔' : '' }}</div>
                          <div class="col">{{ row.po ? '✔' : '' }}</div>
                          <div class="col">{{ row.start_date }}</div>
                          <div class="col">{{ row.last_followup }}</div>
                          <div class="col">{{ row.next_followup }}</div>
                        </div>
                        <div :class="'row list-data'+(row.color?' f-color':'')" :style="(row.color?'background:'+row.color:'')">
                          <div class="col col-check"></div>
                          <div class="col-11 plan-note" style="text-align: left;" @dblclick="editNote(row,'planning_notes')">
                            Notes: 
                            <template v-if="note2edit.id == row.survey_id">
                              <a class="btn btn-xs" @click="note2edit=blanknote">Cancel</a>
                              <a class="btn btn-xs btn-black" @click="saveNote(row)">Save</a>
                              <textarea v-model="note2edit.notes" ref="enote" @keydown.enter.prevent="saveNote(row)" class="form-control"></textarea>
                            </template>
                            <template v-else>
                              {{ row.notes }}
                            </template>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="list-row">
                      <div class="row list-data">
                        <div class="col col-check"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col">Total</div>
                        <div class="col">{{ formatNum(totals[category]) }}</div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                      </div>
                    </div>
                    <div class="list-row" v-if="ghtotals[category]">
                      <div class="row list-data">
                        <div class="col col-check"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col">Processed</div>
                        <div class="col">{{ formatNum(ghtotals[category]) }}</div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                      </div>
                    </div>
                    <div class="list-row" v-if="seltotals[category]">
                      <div class="row list-data">
                        <div class="col col-check"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col">Selected</div>
                        <div class="col">{{ formatNum(seltotals[category]) }}</div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="plannings.length === 0 && !isListLoading">
                <p class="no-results-msg">No results found</p>
              </template>
              <template v-if="isListLoading">
                <div class="progress">
                  <div
                    class="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    aria-valuenow="100"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 100%"></div>
                </div>
              </template>
              <br>
              <template>
                <div class="button-group">
                  <br>
                  <div class="btn-bulk-close position-relative" v-if="checkedPlans.length > 0">
                    <button class="btn" @click="editPlans">Bulk Edit ({{ checkedPlans.length }})</button>
                  </div>
                  <div class="btn-bulk-close position-relative" v-if="checkedPlans.length > 0">
                    <button class="btn" @click="deletePlans">Bulk Delete ({{ checkedPlans.length }})</button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </tab-pane>
        <tab-pane :key="2" :title="'Customs'" :id="2">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <div id="list-projj" class="list-proj">
                  <div class="row list-head">
                    <div class="col">Quote Number</div>
                    <div class="col">Date Submitted</div>
                    <div class="col">Job Name</div>
                    <div class="col">Company Name</div>
                    <div class="col">Amount</div>
                    <div class="col">Status</div>
                    <div class="col">Messages</div>
                  </div>
                  <div class="list-row" v-for="(row, ci) in customs" :key="ci">
                    <template v-if="row">
                      <div :class="'row list-data'+(row.color?' f-color':'')" :style="(row.color?'background:'+row.color:'')" :data-row="row">
                        <div class="col">{{ row.quote_number }}</div>
                        <div class="col">{{ row.updated_at }}</div>
                        <div class="col" style="word-break: break-word;">{{ row.project_name }}</div>
                        <div class="col">{{ row.company_name }}</div>
                        <div class="col">{{ formatNum(row.total) }}</div>
                        <div class="col">{{ row.status }}</div>
                        <div class="col">{{ row.custom_message }}</div>
                      </div>
                      <div  :class="'row list-data'+(row.color?' f-color':'')" :style="(row.color?'background:'+row.color:'')">
                        <div class="col-12 plan-note" style="text-align: left;" @dblclick="editNote(row,'planning_notes')">
                          Notes: 
                          <template v-if="note2edit.id == row.survey_id">
                            <a class="btn btn-xs" @click="note2edit=blanknote">Cancel</a>
                            <a class="btn btn-xs btn-black" @click="saveNote(row)">Save</a>
                            <textarea v-model="note2edit.notes" ref="enote" @keydown.enter.prevent="saveNote(row)" class="form-control"></textarea>
                          </template>
                          <template v-else>
                            <div class="plan-color">
                              <a class="btn btn-yellow" @click="setColor(row,'yellow')"></a>
                              <a class="btn btn-orange" @click="setColor(row,'orange')"></a>
                              <a class="btn btn-white" @click="setColor(row,null)"></a>
                            </div>
                            {{ row.notes }}
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
        <tab-pane :key="3" :title="'Purchased'" :id="3">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <div id="list-projj" class="list-proj">
                  <div class="row list-head">
                    <div class="col">SO Number</div>
                    <div class="col">Quote Number</div>
                    <div class="col">Customer</div>
                    <div class="col">Job Name</div>
                    <div class="col">Amount</div>
                    <div class="col">Status</div>
                  </div>
                  <div class="list-row" v-for="(row, pi) in purchased" :key="pi">
                    <template v-if="row">
                      <div class="row list-data" :data-row="row">
                        <div class="col">{{ row.sap_id }}</div>
                        <div class="col">{{ row.quote_number }}</div>
                        <div class="col">{{ row.company_name }}</div>
                        <div class="col" style="word-break: break-word;">{{ row.project_name }}</div>
                        <div class="col">{{ formatNum(row.total) }}</div>
                        <div class="col">{{ row.status }}</div>
                      </div>
                      <div class="row list-data">
                        <div class="col-12 plan-note" style="text-align: left;" @dblclick="editNote(row,'planning_notes')">
                          Notes: 
                          <template v-if="note2edit.id == row.survey_id">
                            <a class="btn btn-xs" @click="note2edit=blanknote">Cancel</a>
                            <a class="btn btn-xs btn-black" @click="saveNote(row)">Save</a>
                            <textarea v-model="note2edit.notes" ref="enote" @keydown.enter.prevent="saveNote(row)" class="form-control"></textarea>
                          </template>
                          <template v-else>
                            {{ row.notes }}
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="list-row">
                    <div class="row list-data">
                      <div class="col"></div>
                      <div class="col"></div>
                      <div class="col"></div>
                      <div class="col">Total</div>
                      <div class="col">{{ formatNum(ptotal) }}</div>
                      <div class="col"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
        <tab-pane :key="4" :title="'Finals'" :id="4">
          <div class="row">
            <div class="col-lg-12">
              <div class="filter-wrapper">
                <p class="title">Manage Filter:</p>
                <div class="filter-container">
                  <div class="filter-item search-filter">
                    <input type="text" placeholder="Search" v-model="filters.final_search" @keyup.enter="filterList">
                    <button type="button" @click="filterList"><i class="fa fa-search"></i></button>
                  </div>
                  <div class="filter-reset-btn">
                    <a href="javascript:void(0)" title="Refresh" @click="resetFilter">
                      <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <div id="list-projj" class="list-proj">
                  <div class="row list-head lhtab">
                    <div class="col col-check"><input type="checkbox" v-model="all_select_finals" ref="selectAllselectAllFinals" @change="selectAllFinals($event)"></div>
                    <div class="col" data-tab="final" data-key="quote_number"   @click="sortTabList">Quote Number</div>
                    <div class="col" data-tab="final" data-key="project_name"   @click="sortTabList">Project Name</div>
                    <div class="col" data-tab="final" data-key="company_name"   @click="sortTabList">Company Name</div>
                    <div class="col" data-tab="final" data-key="customer_name"  @click="sortTabList">Customer Name</div>
                    <div class="col" data-tab="final" data-key="customer_email" @click="sortTabList">Customer Email</div>
                    <div class="col" data-tab="final" data-key="customer_phone" @click="sortTabList">Customer Phone</div>
                    <!-- <div class="col" data-tab="final" data-key="project_total" @click="sortTabList">Total</div> -->
                    <div class="col" data-tab="final" data-key="last_followup"  @click="sortTabList">Last Follow-up</div>
                    <div class="col" data-tab="final" data-key="next_followup"  @click="sortTabList">Next Follow-up</div>
                  </div>
                  <div v-for="(fprojects, fcategory) in finals" :key="fcategory">
                    <div class="list-row">
                      <div class="row list-data">
                        <div class="col list-category"><h5>{{ fcategory }}</h5> <a @click="selectByFCat(fcategory)">Select All</a></div>
                      </div>
                    </div>
                    <div class="list-row" v-for="(row, pi) in fprojects" :key="pi">
                      <template v-if="row">
                        <div class="row list-data" :class="'row list-data'+(row.color?' f-color':'')" :style="(row.color?'background:'+row.color:'')">
                          <div class="col col-check"><input type="checkbox" :value="row" :category="fcategory" name="checkedFinals" ref="checkedFinals" v-model="checkedFinals" @change="setCheckedFinals"></div>
                          <div class="col">{{ row.quote_number }}</div>
                          <div class="col" style="word-break: break-word;">{{ row.project_name }}</div>
                          <div class="col">{{ row.company_name }}</div>
                          <div class="col">{{ row.customer_name }}</div>
                          <div class="col">{{ row.customer_email }}</div>
                          <div class="col">{{ row.customer_phone }}</div>
                          <!-- <div class="col">{{ formatNum(row.project_total) }}</div> -->
                          <div class="col">{{ row.last_followup }}</div>
                          <div class="col">{{ row.next_followup }}</div>
                        </div>
                        <div :class="'row list-data'+(row.color?' f-color':'')" :style="(row.color?'background:'+row.color:'')">
                          <div class="col-12 plan-note" style="text-align: left;" @dblclick="editNote(row,'planning_notes')">
                            Notes:
                            <template v-if="note2edit.id == row.survey_id">
                              <a class="btn btn-xs" @click="note2edit=blanknote">Cancel</a>
                              <a class="btn btn-xs btn-black" @click="saveNote(row)">Save</a>
                              <textarea v-model="note2edit.notes" ref="enote" @keydown.enter.prevent="saveNote(row)" class="form-control"></textarea>
                            </template>
                            <template v-else>
                              <a class="pdf-slink" v-if="row.pdf_proposal" :href="'/file?f='+row.pdf_proposal" target="_blank">Proposal</a>
                              {{ row.notes }}
                            </template>
                          </div>
                        </div>
                      </template>
                    </div>
                    <!-- <div class="list-row">
                      <div class="row list-data">
                        <div class="col col-check"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col"></div>
                        <div class="col">Total</div>
                        <div class="col">{{ formatNum(ftotals[fcategory]) }}</div>
                        <div class="col"></div>
                        <div class="col"></div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <br>
              <template>
                <div class="button-group">
                  <br>
                  <div class="btn-bulk-close position-relative" v-if="checkedFinals.length > 0">
                    <button class="btn" @click="editFinals">Bulk Edit ({{ checkedFinals.length }})</button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </tab-pane>
      </card>
    </tabs>
    <planning-modal v-if="showPlanningModal" :ids="planning_ids" :qns="planning_qns" :tab="tab" :rdata="editData" :isEdit="isEdit" @close="handleClosePlanning"></planning-modal>
  </div>
</template>
<script>
import PlanningModal from '../components/Modals/PlanningModal';

export default {
  name: 'PlanningDashboard',
  components: {
    PlanningModal
  },
  data() {
    return {
      filters: {
        search: ''
      },
      currentUser: {},
      selectedCopy: {},
      note2edit: {id:0,notes:''},
      blanknote: {id:0,notes:''},
      tabs: {
        final: {
          order_by:'company_name',
          order:'asc'
        }
      },
      checkedPlans: [],
      checkedFinals: [],
      plannings: [],
      customs: [],
      purchased: [],
      finals: [],
      tab: 'planning',
      planning_ids: 0,
      planning_qns: 0,
      totals: [],
      ftotals: [],
      ghtotals: [],
      seltotals: [],
      ptotal: 0,
      notes: [],
      showPlanningModal: false,
      isEdit: true,
      page: 1,
      editData: false,
      isListLoading: false,
      last_page: 1,
      order_by: 'quote_number',
      order: 'desc',
      stopLoads: false,
      waiting: false,
      generating: false,
      checking: false,
      gen3dstart: 0,
      requesting3D: [],
      is3DRequest: false,
      pms: []
    }
  },
  watch: {
      '$route': function() {
          this.me();
          this.getPlannings(1);
      }
  },
  mounted() {
    let def_order = document.querySelector('#list-projj .list-head .col[data-key='+this.order_by+']')
    def_order.classList.add(this.order)
    def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
    document.getElementById("list-projj").addEventListener('scroll', this.scrollList);

    this.me()
    this.getPlannings(1)
  },
  methods: {
    me() {
      if (localStorage.getItem('user')) {
        this.currentUser = JSON.parse(localStorage.getItem('user'))
      } else {
        this.$http.get('/api/me').then((res) => {
          localStorage.setItem('user', JSON.stringify(res.data))
          this.currentUser = res.data
        }).catch(() => {})
      }
    },
    toggleNotes(sid) {
      const index = this.notes.indexOf(sid);
      if (index > -1) {
        this.notes.splice(index, 1);
      } else {
        this.notes.push(sid);
      }
    },
    formatNum(num) {
      return Number(parseFloat(num).toFixed(2)).toLocaleString('en-US',{minimumFractionDigits: 2,maximumFractionDigits: 2 });
    },
    setCheckedPlans() {
      this.seltotals = [];
      if ( this.checkedPlans.length > 0 ) {
        for(let n in this.checkedPlans){
          this.seltotals[this.checkedPlans[n].category] += parseFloat(this.checkedPlans[n].project_total);
        }
      }
    },
    selectedTotals(cat) {
      var seltot = 0;
      if ( this.checkedPlans.length > 0 ) {
        for(let n in this.checkedPlans){
          if ( this.checkedPlans[n].category == cat ) {
            seltot += parseFloat(this.checkedPlans[n].project_total);
          }
        }
      }
      return seltot;
    },
    selectAll(e) {
      console.log(this.$refs.checkedPlans)
      for (let n in this.$refs.checkedPlans) {
        if ( this.$refs.checkedPlans[n].checked != e.target.checked ) {
          this.$refs.checkedPlans[n].click();
        }
      }
    },
    selectAllFinals(e) {
      console.log(this.$refs.checkedFinals)
      for (let n in this.$refs.checkedFinals) {
        if ( this.$refs.checkedFinals[n].checked != e.target.checked ) {
          this.$refs.checkedFinals[n].click();
        }
      }
    },
    selectByCat(cat) {
      for (let n in this.$refs.checkedPlans) {
        if ( this.$refs.checkedPlans[n].getAttribute('category') == cat ) {
          if ( !this.$refs.checkedPlans[n].checked ) {
            this.$refs.checkedPlans[n].click();
          }
        } else if ( this.$refs.checkedPlans[n].checked ) {
          this.$refs.checkedPlans[n].click();
        }
      }
    },
    selectByFCat(cat) {
      for (let n in this.$refs.checkedFinals) {
        if ( this.$refs.checkedFinals[n].getAttribute('category') == cat ) {
          if ( !this.$refs.checkedFinals[n].checked ) {
            this.$refs.checkedFinals[n].click();
          }
        } else if ( this.$refs.checkedFinals[n].checked ) {
          this.$refs.checkedFinals[n].click();
        }
      }
    },
    editNote(r,d4) {
      this.note2edit = {
        id : r.survey_id,
        notes : r.notes,
        datafor : d4,
      };
      this.$nextTick(() => {
        this.$refs["enote"][0].focus()
      })
    },
    saveNote(r) {
      this.isSubmitting = true
      let fdata = new FormData()

      var ids = [this.note2edit.id]
      for(let n in ids) {
          fdata.append(`ids[${n}]`, ids[n])
      }

      var edit_fields = ['notes']
      for(let n in edit_fields) {
          fdata.append(`edit_fields[${n}]`, edit_fields[n])
      }

      for(let n in this.note2edit) {
          fdata.append(n, this.note2edit[n])
      }

      this.$http.post('/api/planning/update/1', fdata)
          .then(() => {
              r.notes = this.note2edit.notes;
              this.note2edit = this.blanknote
              this.getPlannings(1)
          })
          .catch(error => {
              if(error.response.data.message == 'validation_error') {
                  alert(error.response.data.errors)
              }
          })
      return false;
    },
    setColor(r,color) {
      this.isSubmitting = true
      let fdata = new FormData()

      var ids = [r.id]
      for(let n in ids) {
          fdata.append(`ids[${n}]`, ids[n])
      }

      var edit_fields = ['color']
      for(let n in edit_fields) {
          fdata.append(`edit_fields[${n}]`, edit_fields[n])
      }

      var edits = {color:color,datafor:'planning_notes'}
      for(let n in edits) {
          fdata.append(n, edits[n])
      }

      this.$http.post('/api/planning/update/1', fdata)
          .then(() => {
              r.color = color;
          })
      return false;
    },
    editPlans() {
      this.planning_ids = [];
      this.planning_qns = [];
      this.editData = false;
      this.tab = 'planning';
      for(let n in this.checkedPlans){
        this.planning_ids.push( this.checkedPlans[n].id );
        this.planning_qns.push( this.checkedPlans[n].quote_number );
      }
      if ( this.checkedPlans.length == 1 ) {
        this.editData = this.checkedPlans[0];
        console.log('checkedPlans[0]',this.checkedPlans[0])
      }
      this.showPlanningModal = true;
    },
    editFinals() {
      this.planning_ids = [];
      this.planning_qns = [];
      this.editData = false;
      this.tab = 'finals';
      for(let n in this.checkedFinals){
        this.planning_ids.push( this.checkedFinals[n].survey_id );
        this.planning_qns.push( this.checkedFinals[n].quote_number );
      }
      if ( this.checkedFinals.length == 1 ) {
        this.editData = this.checkedFinals[0];
        console.log('checkedFinals[0]',this.checkedFinals[0])
      }
      this.showPlanningModal = true;
    },
    deletePlans() {
      var qns = [], ids = [];
      for(let n in this.checkedPlans){
        ids.push( this.checkedPlans[n].id );
        qns.push( this.checkedPlans[n].quote_number );
      }
      if ( confirm('Are you sure you want to Delete selected Plans below?\n'+ qns.join(', ')) ) {
        let fdata = new FormData()

        for(let n in ids) {
            fdata.append(`ids[${n}]`, ids[n])
        }

        this.$http.post('/api/planning/delete', fdata)
          .then(() => {
              this.handleClosePlanning()
          })
          .catch(error => {
            if(error.response.data.message == 'validation_error') {
                    console.log(error.response.data.errors)
                }
            })
      }
    },
    handleClosePlanning() {
        this.planning_ids = 0
        this.planning_qns = 0
        this.showPlanningModal = false
        this.checkedPlans = []
        this.checkedFinals = []
        this.seltotals = []

        this.$refs.selectAll.checked = false

        this.getPlannings(1)
    },
    getPms() {
      this.$http.get(`/api/project-filter-pms`).then((response) => {
        if (response.data.pms) {
          this.pms = response.data.pms
          if (this.pms.includes(this.currentUser.username)) {
            this.filters.pm = this.currentUser.username
          }
        }
        this.getPlannings(1)
      })
    },
    getPlannings(page) {
      console.log(page);
      this.isListLoading = true

      var dataParams = {
        s : this.filters.search,
        final_s : this.filters.final_search,
      }
      var th = '';

      for(var t in this.tabs) {
        th = this.tabs[t];
        dataParams[t+'_order_by'] = th.order_by
        dataParams[t+'_order'] = th.order
      }

      this.$http.get(`/api/planning/list`,{ params: dataParams }).then((response) => {
        this.isListLoading = false
        if (response.data.plannings) {
          this.plannings = response.data.plannings
          this.customs = response.data.customs
          this.purchased = response.data.purchased
          this.finals = response.data.finals
          this.totals = response.data.totals
          this.ghtotals = response.data.ghtotals
          this.ptotal = response.data.ptotal
          this.ftotals = response.data.ftotals
          console.log(this.plannings);
          for ( var x in this.plannings) {
            console.log(this.plannings[x]);
          }
        }
      }).catch(error => {
        console.log(error)
        this.isListLoading = false
      })
    },
    scrollList({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= (scrollHeight - 100) && !this.stopLoads && !this.isListLoading) {
        this.page += 1;
        this.getPlannings(this.page);
      }
    },
    sortList(e) {
      if(!this.isListLoading) {
        Array.from(document.querySelectorAll('#list-projj .list-head .col')).forEach((el) => {
            el.classList.remove('asc', 'desc')
        })
        let element = document.querySelector('#list-projj .list-head .col[data-key='+e.target.dataset.key+']')
        this.order_by = e.target.dataset.key
        this.order = element.dataset.order || 'asc'
        element.classList.add(this.order)
        element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
        this.page = 1
        this.plannings = []
        this.getPlannings(1)
      }
    },
    sortTabList(e) {
      if(!this.isListLoading) {
        Array.from(document.querySelectorAll('#list-projj .list-head.lhtab .col')).forEach((el) => {
            el.classList.remove('asc', 'desc')
        })
        let element = document.querySelector('#list-projj .list-head.lhtab .col[data-key='+e.target.dataset.key+']')
        let tab = e.target.dataset.tab
        this.tabs[tab].order_by = e.target.dataset.key
        this.tabs[tab].order = element.dataset.order || 'asc'
        element.classList.add(this.tabs[tab].order)
        element.dataset.order = (this.tabs[tab].order == 'asc' ? 'desc' : 'asc')
        this.page = 1
        this.plannings = []
        this.getPlannings(1)
      }
    },
    filterList() {
      this.page = 1
      this.plannings = []
      this.getPlannings(1)
    },
    resetFilter() {
      this.filters = { search: '', final_search: '' }
      this.filterList()
    },
    edit(row) {
      this.$router.push(`/drawings/edit/${row.id}`)
    },
    checkWaiting() {
      const api = '/api/duplicate-drawings/check/waiting';
      let waiting = [];
      this.plannings.map(function(o, i) {
        if ( o.drawing_status == "waiting" ) waiting.push({ key : i, id : o.id })
      })
      this.$http.get(api).then((response) => {
        for(let w in waiting) this.plannings[waiting[w].key].drawing_status = 'generating';
        if ( response.data.length ) this.checkDrawings();
      })
    },
    checkDrawings() {
      if ( this.checking ) return false

      let generating = []
      this.plannings.map(function(o, i) {
          if ( o.drawing_status == "generating" ) generating.push({ key : i, id : o.id })
      });
      this.generating = generating
      if ( !generating.length ) return false

      const api = '/api/duplicate-drawings/check/generated'
      let dataParams = { ids : [] }
      for ( let i in this.generating ) dataParams.ids.push(this.generating[i].id)
      this.checking = true
      this.$http.get(api,{ params: dataParams }).then((response) => {
        this.checking = false
        const genProjects = response.data.generated
        if ( genProjects.length > 0 ) {
          for(let i in genProjects ) {
            let proj = this.generating.filter(p => p.id == genProjects[i].id)
            if ( proj.length > 0 ) {
              this.$set(this.plannings, proj[0].key, genProjects[i])
              alert(genProjects[i].quote_number + ' drawing has been generated.')
            }
          }
        } else if ( this.$route.path === '/drawings' ) {
          setTimeout(this.checkDrawings, 5000)
        }
      })
      .catch((error) => {
        console.log(error)
        this.checking = false
      })
    },
    request3D(project_id, index) {
      this.requesting3D.push(project_id);
      const api = '/api/duplicate-drawings/request3D/'+project_id;
      this.$http.get(api).then((response) => {
        var r = response.data;
        // console.log('respo request 3D', r);
        if ( r.status == 'success' ) this.$set(this.plannings, index, r.copy);
        if ( r.status == 'waiting' ) {
          alert('Waiting for 3D to be generated');
          this.$set(this.plannings[index], 'requested_3d', 'Yes');
          this.check3Ds();
        }

        if ( r.status == 'failed' ) {
          alert('Error: ' + r.message);
        } else {
          for ( var r3 in this.requesting3D ) {
            if ( this.requesting3D[r3] == project_id ) delete this.requesting3D[r3];
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    check3Ds() {
      if ( this.is3DRequest ) return false;
      const api = '/api/duplicate-drawings/check/generated3D';
      var dataParams = { ids : [] };
      this.plannings.map(function(o){
        if ( o.requested_3d == "Yes" && !o.file_3d ) dataParams.ids.push(o.id);
      });
      this.is3DRequest = true;
      if ( dataParams.ids === [] ) return false;

      this.$http.get(api,{ params: dataParams }).then((response) => {
        this.is3DRequest = false;
        const genProjects = response.data.generated;
        if ( genProjects.length > 0 ) {
          for(var x in genProjects ) {
            this.plannings.map(function(o,i){
              if ( o.id == genProjects[x].id && genProjects[x].file_3d ) {
                alert(genProjects[x].quote_number+' 3D has been generated.');
                o.file_3d = genProjects[x].file_3d;
                this.$set(this.plannings[i], 'file_3d', genProjects[x].file_3d);
                this.$set(this.plannings[i], 'requested_3d','');

                for ( var r3 in this.requesting3D ) {
                  if ( this.requesting3D[r3] == o.id ) delete this.requesting3D[r3];
                }
              }
            });
            this.reset();
          }
        } else if ( this.$route.path === '/drawings' ) {
          setTimeout(this.check3Ds, 5000);
        }
      })
      .catch((error) => {
          console.log(error)
          this.is3DRequest = false;
      });
    },
  }
}
</script>
<style lang="scss" scoped>
@media (min-width: 1200px) {
    #extended-container {
        width: calc(100vw -((100vw - 1170px) / 2) - 330px);
        max-width: 1200px;
    }
    .page-content {
      .main-content {
        margin-left: calc((100vw - 1170px) / 4);
      }
    }
}
.plan-note {
  background: #00000080 !important;
  color: #FFF !important;

  &.col-12 {
    padding-left: 26px;
  }

  textarea.form-control {
    font-size: 11px;
  }
}
#list-projj {
    min-width: 700px;
    padding-right: 12px;

    .col-check {
        padding: 12px 0 0 8px;
        max-width: 38px !important;
        text-align: right;
    }

    .list-head {
      &.lhtab {
        .col {
          white-space: normal;
          background-image: url('/api/public/img/bg.png');
          background-position: center right;
          background-repeat: no-repeat;
          cursor: pointer;
          vertical-align: middle;

          &.asc {
            background-image: url('/api/public/img/trans-asc.png');
          }
          &.desc {
            background-image: url('/api/public/img/trans-desc.png');
          }
          &.sort-false {
            background-image: none;
            cursor: default;
          }
        }
      }
    }
}
.plan-color {
  float: right;
  opacity: 0;

  .btn {
    width: 18px;
    height: 12px;
    border-radius: 0px;
    margin: 0px !important;

    &.btn-yellow {
      background: yellow;
    }

    &.btn-orange {
      background: orange;
    }

    &.btn-white {
      background: white;
    }
  }
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
#list-projj {
  .list-row {
    .list-data {
      &.f-color {
        .col {
          background: inherit;
        }
      }
    }

    &:hover {
      .list-data{
        background: #102e6c !important;
      }

      .plan-color {
        opacity: 1;
      }
    }
  }
}
.list-row {
  .list-data {
    .col.list-category {
      background: #347ab5;

      h5 {
        margin: 0;
        text-transform: uppercase;
        color: #FFF;
        font-size: 11px;
        letter-spacing: 1px;
        display: inline;
      }

      a {
        color: #FFF;
        font-size: smaller;
      }
    }

    .pdf-slink {
      float: right;
      color: #FFF;
      margin: 0 0 0px 4px;
      line-height: 5px;
    }
  }
}
.list-proj .row>div a.btn-xs {
    padding: 0px 8px;
    font-size: 10px;
    border: none;
    border-radius: 0px;
    margin: 0 0px 4px 4px;
    float: right;
}
.row-detail {
    display: flex;
    align-items: center;
    word-break: break-all;
    padding: 0.2em;
    label {
        min-width: 130px;
        font-weight: bold;
        margin: 0;
    }
}
.modal-view.modal::v-deep {
    .modal-dialog {
        max-width: 992px;
    }
}
.modal-approve.modal::v-deep {
    .modal-dialog {
        max-width: 768px;
    }
}
.list-proj .row .action { display: inline-block; padding: 7px; border: 0; letter-spacing: 0.3px; color: #fff; text-decoration: none; min-width: 86px; cursor: pointer; color: #fff; background-color: #5cb85c; margin-left: 6px; vertical-align: middle; }
.list-proj .row .action span { display: inline-block; background: #459e45; padding: 2px 7px; width: 29px; margin: -7px 2px -7px -8px; font-size: 17px; line-height: 26px; text-align: center; }
.list-proj .row .action.action-red { background: #c90000; }
.list-proj .row .action.action-red span { background: #8b0000; }
.badge {
    cursor: text;
    pointer-events: none;
    border-radius: 0;
    min-width: 84px;
    padding: 7px;
    border: 0;
    letter-spacing: .3px;
    color: #fff;
    text-decoration: none;
}
.badge-pending {
    background-color: gold;
}
.badge-approved {
    background-color: #459e45;
}
.badge-rejected {
    background-color: #c90000;
}
@media (max-width: 768px) {
    #list-projj {
        min-width: 1200px;
    }
}
@media (min-width: 1200px) {
    .filter-wrapper {
        .filter-item {
            width: 19.4%;
            &.search-filter {
                width: 29.6% !important;
            }
        }
    }
}

.filter-wrapper {
    .filter-item {
        &.filter-legend {
            width: 66%;
            margin: -28px 0 0 12px;
            padding: 6px;
            position: relative;
            border: 1px solid #676767;
            height: auto;

            span {
                position: absolute;
                top: -10px;
                left: 4px;
                background: #dad9d9;
                padding: 0 4px;
            }

            .legend {
                display: inline-block;
                padding: 4px;
                width: 175px;
                margin: 2px 4px;
            }
        }
    }
}
@media (max-width: 1240px) {
    .filter-wrapper {
        .filter-item {

            &.filter-legend {
                width: 100%;
                margin: 10px 0 0;
            }
        }
    }
}
</style>
